import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema, toParagraphContent } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/automations'],
  validationMode: 'any',
};

export const appointmentAutomationsStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.AppointmentAutomations,
  category: PracticeSetupStepCategory.AdditionalSettings,
  title: 'Configure Appointment Automations',
  description: initRawSchema([
    toParagraphContent(
      `Principle's Automation Configuration page allows you to set up automated tasks and notifications that are triggered by appointments in your workspace. The Appointment tab specifically contains automations that apply to every appointment booked, regardless of the treatment involved.`
    ),
    toParagraphContent(
      `This is where you configure practice-wide appointment communications such as reminder notifications sent two days before or one week before an appointment. Because these automations apply universally, they are the foundation of your patient communication strategy in Principle.`
    ),
  ]),
  dependsOn: [],
  getRoute: (brand, _practice) => `settings/brand/${brand.ref.id}/automations`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: 'Please review this page to complete this step',
        };
      })
    );
  },
  pageVisitTracking,
};
